<div class="row reset-password">
  <div class="col-12 mt-4 text-center">
    <div class="reset-form">
      <h3 class="description-text">
        {{ 'RESET-PASSWORD.TITLE-TEXT' | translate }} <br />
      </h3>

      <form class="username-or-email">
        <mat-form-field class="form-field">
          <input
            autocomplete="off"
            matInput
            placeholder="{{
              'RESET-PASSWORD.USERNAME-EMAIL-LABEL' | translate
            }}"
            id="usernameOrEmail"
            [(ngModel)]="usernameOrEmail"
            #UsernameOrEmail="ngModel"
            name="usernameOrEmail"
            required
          />
        </mat-form-field>
      </form>
      <p *ngIf="adminEmails" class="error-message sentens">
        {{ 'RESET-PASSWORD.USER-BLOCKED' | translate }} <br />
        <span class="email" *ngIf="adminEmails.carrierAdminEmail">
          {{ 'RESET-PASSWORD.CARRIER-ADMIN' | translate }}:
          <a href="{{ 'mailto:' + adminEmails.carrierAdminEmail }}">
            {{ adminEmails.carrierAdminEmail }}
          </a>
          <br />
        </span>
        <span class="email" *ngIf="adminEmails.portalAdminEmail">
          {{ 'RESET-PASSWORD.PORTAL-ADMIN' | translate }}:
          <a href="{{ 'mailto:' + adminEmails.portalAdminEmail }}">
            {{ adminEmails.portalAdminEmail }}
          </a>
        </span>
      </p>

      <div>
        <a [routerLink]="['/login']" class="back-link">{{
          'REGISTRATION.BACK-TO-LOGIN' | translate
        }}</a>
        <button
          [disabled]="!this.usernameOrEmail"
          class="btn btn-primary btn-large loading-button submit-btn"
          (click)="resetPassword()"
        >
          {{ 'RESET-PASSWORD.RESET-PASSWORD-BUTTON' | translate }}
        </button>
      </div>
    </div>
  </div>
  <!-- Col -->
</div>
<!-- Row -->
